import ReactMarkdown from 'react-markdown'
import { normalizeArticleMarkdown } from '../../utils/articleMarkdown'

/**
 * Renderer produktbeskrivelse som formateret HTML (overskrifter, lister, fed skrift).
 */
export function ArticleMarkdown({ content, className = '' }) {
  const normalized = normalizeArticleMarkdown(content || '')
  if (!normalized) return null

  return (
    <div className={className || undefined}>
      <ReactMarkdown>{normalized}</ReactMarkdown>
    </div>
  )
}
